import { type FetchEventSourceInit } from '@microsoft/fetch-event-source'

import { getApiEventSourceClient } from '../../../services/getApiEventSourceClient'

/**
 * Get item description generated by AI. It returns content via SSE.
 *
 * @endpoint GET /ai/item/description/generate
 * @scope shared
 * @see MISSING_URL
 */
export function getAIItemDescription(
  title: string,
  options?: GetAIItemDescriptionOptions
) {
  const eventSource = getApiEventSourceClient()
  let path = `api/ai/item/description/generate?title=${encodeURI(title ?? '')}`

  if (options?.wait) {
    path = `${path}&wait=${options.wait}`
  }

  return eventSource.get(path, options)
}

export type GetAIItemDescriptionOptions = FetchEventSourceInit & {
  wait?: number
}
